import React from "react";
import { Row, Col } from "react-bootstrap";
import FinalCartRow from "../FinalCartRow/index";
import { FaRupeeSign } from "react-icons/fa";
import "./styles.scss";

export default function FinalCart(props) {
  const {
    cart,
    deleteProductFromCart,
    addToCart,
    isMobile,
    cartAmount,
    showAlert,
    loggedIn,
    showLogin,
  } = props;

  return (
    <div className="text-center mt-4 mb-4" id="product-pricing">
      <div className="heading">
        <h2 className="text-capitalize">Selected Products</h2>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        {!loggedIn && (
          <div
            className="text-nowrap signup-intimation"
            onClick={() => showLogin()}
          >
            Login to see Final Cart
          </div>
        )}
        <div
          className={`final-cart-container mx-auto ${!loggedIn ? "blur" : ""}`}
        >
          <Row className="final-cart-row-heading">
            {[
              { title: "Product", size: 4 },
              { title: "Quantity", size: 4 },
              { title: "Total", size: 2 },
              { size: 2 },
            ].map((element) => (
              <Col xs={element.size}>
                <strong>{element.title || ""}</strong>
              </Col>
            ))}
          </Row>
          <hr className="sep-3" />
          {cart.map((element, index) => (
            <FinalCartRow
              key={`final-cart-row-${index}`}
              element={element}
              deleteProductFromCart={deleteProductFromCart}
              addToCart={addToCart}
              isMobile={isMobile}
              showAlert={showAlert}
            />
          ))}
          <Row>
            <Col sm={1}></Col>
            <Col></Col>
            <Col className="final-cart-row-total">
              <div>
                Total Products: <span>{cart.length}</span>
              </div>
            </Col>
            <Col className="final-cart-row-total">
              <div>
                Total:
                <FaRupeeSign
                  size={isMobile ? 15 : 32}
                  className="mr-1 ml-1 align-self-center"
                />
                {cartAmount}
              </div>
            </Col>
          </Row>
          <hr className="sep-3" />
        </div>
      </div>
    </div>
  );
}
